import { useEffect, useState } from "react";
import { LoginIntent } from "../enums/LoginIntent";
import LoginUrlService from "../utilities/loginUrlService";

function useLoginUrl(loginIntent?: LoginIntent) {
  const [loginUrl, setLoginUrl] = useState("");

  useEffect(() => {
    const loginUrlSub = LoginUrlService.get(loginIntent).subscribe(
      (loginUrl) => {
        setLoginUrl(loginUrl);
      }
    );

    return () => {
      loginUrlSub.unsubscribe();
    };
  }, [loginIntent]);

  return loginUrl;
}

export default useLoginUrl;
